// Import Firebase functions from the SDKs
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDPO25O0hxYnPfLaaK3NMudAG0aZoNulow",
    authDomain: "em-s-d2fb1.firebaseapp.com",
    projectId: "em-s-d2fb1",
    storageBucket: "em-s-d2fb1.appspot.com",
    messagingSenderId: "245347085727",
    appId: "1:245347085727:web:6c6e081e4eb5b5e916a1aa",
    measurementId: "G-Z9VHT4C389"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore (Database)
const db = getFirestore(app);

// Initialize Firebase Authentication
const auth = getAuth(app);

// Initialize Firebase Storage
const storage = getStorage(app);

// Export the Firebase services to use in your React components
export { db, auth, storage };
